import { Component, OnInit, Input, HostBinding, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';
import CalendarUtils from './calendar.component.utils';
import CalendarUtilsExtended from './calendar.component.utils-extended';
import { UtilsService } from '../../../services/utils/utils.service';
import { CalendarBaseModel } from '../../../../core/models/calendar-base.model';
import { CalendarNormalModel } from '../../../../core/models/calendar-normal.model';
import { Numbers } from '../../../../../app/utils/constants';
import * as moment from 'moment';
import { UpdateDataCalendar } from 'src/app/core/models/update-data-calendar.model';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit, OnChanges {
  /**
   * @ignore
   */
  constructor(public utilsSrv: UtilsService ) {
    this.utils = new CalendarUtils();
    this.utilsSrv = utilsSrv;
    this.utilsExtended = new CalendarUtilsExtended();
  }

  @Input() FORM_DATA: FormGroup;
  @Input() DATA_CONFIG: CalendarBaseModel | CalendarNormalModel | any;
  @Input() CAL_TYPE: 'range' | 'normal' = 'normal';
  @Input() CHANGE_MAX: any;
  @Input() PRODUCT_CHOOSE: any;
  @Input() TYPE_BORN: any;
  @HostBinding('class.w_max') widthMax = true;
  @ViewChild('datePicker', { read: null, static: null }) calendar: any;

  public finishSubs = new Subject();
  fieldName: any;
  fieldName2: any;
  fieldName3: any;
  isSimple = false;
  calledFrom = '';
  errorFormat = false;
  errorMinB = false;
  errorMinB101 = false;
  public showedCalendar = false;
  number70 = 70;
  isChange = false;
  dateBValue: Date;
  public utils: CalendarUtils;
  public utilsExtended: CalendarUtilsExtended;
  public previousVal: string;
  tempFormData: FormGroup;

  /**
   * @ignore
   */
  ngOnInit(): void {
    this.utilsExtended.initUtils();
    if (!this.checkDataCompOk()) { return; }
    this.isSimple = false;
    if (this.CAL_TYPE === 'range') {
      this.initialize();
    }
    if (this.CAL_TYPE === 'normal') {
      const TIME_SET: any = setTimeout(() => {
        this.initializeNormal();
        clearTimeout(TIME_SET);
      }, Numbers.timeOut20);
    }
    this.utilsExtended.getCurrentInsure(this.DATA_CONFIG);
  }

  /**
   * @ignore
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.CHANGE_MAX !== undefined && changes.CHANGE_MAX.currentValue !== undefined) {
      this.utils.changeDataV = true;
      if (this.CAL_TYPE === 'range') {
        this.initialize();
      }
      if (this.CAL_TYPE === 'normal') {
        this.initializeNormal();
      }
    }
    /* this.utils.insureSelected = this.DATA_CONFIG.start.linkFormPath[0];
    this.utils.setReadOnly(this.FORM_DATA.get(this.utils.insureSelected).value.insuranceDuration); */
  }

  /**
   * @ignore
   */
  toggleCalendar(calledFrom: 'from' | 'to'): void {
    if (calledFrom === 'to' && this.utils.readonlyEnd) {
      this.calledFrom = calledFrom;
    } else {
      this.calendar.toggle();
      this.calledFrom = calledFrom;
      if (this.CAL_TYPE === 'range') {
        setTimeout(() => {
          this.utilsExtended.stylesCalendar();
        }, Numbers.timeOut20);
      }
    }
  }

  /**
   * @ignore
   */
  /* ngAfterViewInit(): void {
    this.utils.insureSelected = this.DATA_CONFIG.start.linkFormPath[0];
    this.utils.setReadOnly(this.FORM_DATA.get(this.utils.insureSelected).value.insuranceDuration);
    this.changeDetector.detectChanges();
  } */

  /**
   * @ignore
   */
  initialize(): void {
    this.utils.insureSelected = this.DATA_CONFIG.start.linkFormPath[0];
    this.tempFormData = this.FORM_DATA;
    if (this.isChange) {
      this.FORM_DATA.get(this.DATA_CONFIG.end.linkFormPath).setValue('');
      this.utils.accumulatorDays = 0;
      this.isChange = false;
    }
    this.utils.dateStart = this.FORM_DATA.get(this.DATA_CONFIG.start.linkFormPath).value;
    this.utils.dateEnd = this.FORM_DATA.get(this.DATA_CONFIG.end.linkFormPath).value;
    this.utils.textInput1 = this.utils.dateStart;
    this.utils.textInput2 = this.utils.dateEnd;
    if (this.CAL_TYPE === 'range') {
      this.utils.readonlyEnd = false;
      this.utils.minDate = new Date();
      if (this.utils.insureSelected !== 'particularTravelAsistance') {
        this.utils.minDate.setDate(new Date().getDate() + 1);
      }
      this.utils.maxDateV = '';
      if (this.FORM_DATA.get(this.DATA_CONFIG.start.linkFormPath).value.length === 0) {
        this.FORM_DATA.get(this.DATA_CONFIG.start.linkFormPath).setValue(
          this.utils.parseDateToShort(this.DATA_CONFIG.start.value));
        this.utils.textInput1 = this.utils.parseDateToShort(this.DATA_CONFIG.start.value);
      }
      if (this.FORM_DATA.get(this.DATA_CONFIG.end.linkFormPath).value.length === 0) {
        this.FORM_DATA.get(this.DATA_CONFIG.end.linkFormPath).setValue(this.utils.parseDateToShort(this.DATA_CONFIG.end.value));
        this.utils.textInput2 = this.utils.parseDateToShort(this.DATA_CONFIG.end.value);
      }
      this.utils.valDuration = this.FORM_DATA.get(this.DATA_CONFIG.start.linkFormPath[0]).value.insuranceDuration;
      this.initializeValDuration(this.DATA_CONFIG);

      if (this.FORM_DATA.get(this.DATA_CONFIG.end.linkFormPath).value === '' && this.utils.textInput2 !== '') {
        this.utils.textInput2 = '';
      }

      this.fieldName = this.DATA_CONFIG.start.linkFormPath;
      this.fieldName2 = this.DATA_CONFIG.end.linkFormPath;
      this.utils.fieldRequired = this.DATA_CONFIG.start.required;
      this.utils.fieldRequired2 = this.DATA_CONFIG.end.required;
      this.getError(this.fieldName, Numbers.number1);
      this.getError(this.fieldName2, Numbers.number2);
    }
  }

  /**
   * @ignore
   */
  initializeValDuration(DATA_CONFIG: any): void {
    if (!this.previousVal) {
      this.previousVal = 'Temporal';
    }
    this.utils.readonlyEnd = false;
    if (this.utils.valDuration === 'Temporal' || this.utils.valDuration === 'form1.duration-temporal') {
      this.utils.initializeValDurationUtils1(this.FORM_DATA, this.DATA_CONFIG, this.previousVal);
      this.utils.readonlyEnd = true;
    }
    if ((this.utils.valDuration === 'Anual' && (this.utils.dateEnd === '' || this.utils.changeDataV)) ||
      (this.utils.valDuration === 'Larga Estancia' && (this.utils.dateEnd === '' || this.utils.changeDataV))) {
      this.utils.initializeValDurationUtils2(this.FORM_DATA, this.DATA_CONFIG);
      this.FORM_DATA = this.utils.formDataUtils;
      this.calculateDays2(this.utils.minDate, this.utils.maxDate, DATA_CONFIG);
      this.utils.readonlyEnd = true;
    }
    this.previousVal = this.utils.valDuration;
  }

  /**
   * @ignore
   */
  initializeNormal(): void {
    this.utils.insureSelected = this.PRODUCT_CHOOSE;
    this.manageCalendar();
    this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).valueChanges
      .pipe(
        takeUntil(this.finishSubs),
        distinctUntilChanged(),
        tap(value => {
          this.calendar.inputFieldValue = value;
          if ((this.utils.insureSelected === 'particularTravelAsistance' ||
            this.utils.insureSelected === 'individualTravelAsistance') && this.TYPE_BORN === 'sport') {
            this.FORM_DATA.get(['prima']).setValue(Numbers.number1);
          }
          if ((this.utils.insureSelected === 'particularTravelAsistance' ||
            this.utils.insureSelected === 'individualTravelAsistance') && (this.TYPE_BORN === 'mayor70' ||
              this.TYPE_BORN === 'mayor60')) {
            this.FORM_DATA.get(['prima']).setValue(Numbers.number24);
          }
          if ((this.utils.insureSelected === 'particularTravelAsistance' ||
            this.utils.insureSelected === 'individualTravelAsistance') && this.TYPE_BORN !== 'mayor70' &&
            this.TYPE_BORN !== 'mayor60' && this.TYPE_BORN !== 'sport') {
            this.FORM_DATA.get(['prima']).setValue(Numbers.number0);
          }
        })
      ).subscribe();
  }

  /**
   * @ignore
   */
  public checkDataCompOk(): boolean {
    if (!this.FORM_DATA) {
      this.FORM_DATA = this.tempFormData;
    }
    return !!(this.FORM_DATA && this.DATA_CONFIG);
  }

  /**
   * @ignore
   */
  calculateDays2(from: Date, to: Date, DATA_CONFIG: any): void {
    if (from !== null && to !== null) {
      let accumulator = 0;
      this.utilsExtended.getCurrentInsure(DATA_CONFIG);
      const TO_DATE: moment.Moment = moment(this.utilsSrv.parseDateToShortDay(to), 'DD-MM-YYYY');
      accumulator = TO_DATE.diff(moment(this.utilsSrv.parseDateToShortDay(from), 'DD-MM-YYYY'), 'days');
      this.utils.accumulatorDays = accumulator;
      if (!this.FORM_DATA) {
        this.FORM_DATA = this.tempFormData;
      }
      this.FORM_DATA.get([this.utilsExtended.currentInsure, 'insuranceTime']).setValue(accumulator);
    }
  }

  /**
   * @ignore
   */
  updateData(evento: any, type?: string): void {
    if (this.CAL_TYPE === 'range') {
      this.updateRange(type);
    }
    if (this.CAL_TYPE === 'normal') {
      let isEsvent = false;
      if (evento !== undefined) {
        isEsvent = true;
      }
      const AUX_B_VAL_CAL: any = evento;
      const AUX_B_VAL: string = this.utils.textInput3;
      // tslint:disable-next-line: prefer-const
      let inputValMinE = false;
      let auxBVal2: any = AUX_B_VAL.split('/');
      let auxBVal3: any = null;
      // tslint:disable-next-line: prefer-const
      let dateShort: string;
      this.calendar.value = '';
      // tslint:disable-next-line: prefer-const
      let updatedData: UpdateDataCalendar = {
        AUX_B_VAL,
        auxBVal2,
        auxBVal3,
        AUX_B_VAL_CAL,
        inputValMinE,
        dateShort
      };
      auxBVal2 = new Date(auxBVal2[Numbers.number1] + '-' + auxBVal2[Numbers.number0] + '-' + auxBVal2[Numbers.number2]);
      auxBVal3 = null;
      if (AUX_B_VAL !== '') {
        auxBVal3 = auxBVal2;
      }
      if (!isNaN(auxBVal2.getTime()) && !isEsvent) {
        this.updateDataIsNotEsvent(updatedData);
      } else if (!isNaN(AUX_B_VAL_CAL.getTime())) {
        this.updateDataIsEsvent(updatedData);
      } else {
        updatedData.dateShort = '';
        auxBVal3 = null;
        this.dateBValue = null;
        this.utils.textInput3 = updatedData.dateShort;
        this.errorFormat = true;
      }
      if (!updatedData.inputValMinE) {
        this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setValue(updatedData.dateShort);
        this.utils.formDataUtils = this.FORM_DATA;
        this.utils.errorType = Numbers.number3;
        this.utils.setErrorField(updatedData.dateShort, this.DATA_CONFIG.linkFormPath, this.utils.fieldHasErrorB3,
          this.CAL_TYPE, this.DATA_CONFIG, this.TYPE_BORN, this.calendar);
        this.FORM_DATA = this.utils.formDataUtils;
      }
    }
  }

  /**
   * @ignore
   */
  updateDataIsNotEsvent(updatedData: UpdateDataCalendar): void {
    const AUX_ACTUAL_DATE = new Date();
    const AUX_ACTUAL_DATE_101 = new Date();
    AUX_ACTUAL_DATE_101.setDate(Numbers.numberN101);
    AUX_ACTUAL_DATE.setHours(0, 0, 0, 0);
    const AUX_FIELD_BDATE = new Date(updatedData.auxBVal2);
    if (AUX_ACTUAL_DATE.getTime() <= AUX_FIELD_BDATE.getTime()) {
      this.errorMinB = true;
      this.errorMinB101 = false;
      updatedData.dateShort = '';
      updatedData.auxBVal3 = null;
      this.dateBValue = null;
      updatedData.inputValMinE = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    } else if (AUX_ACTUAL_DATE_101.getTime() <= AUX_FIELD_BDATE.getTime()) {
      this.errorMinB = false;
      this.errorMinB101 = true;
      updatedData.dateShort = '';
      updatedData.auxBVal3 = null;
      this.dateBValue = null;
      updatedData.inputValMinE = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    } else {
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === Numbers.number0;
      }
      errorsA = ERRORS;
      if (errorE === true) {
        errorsA = null;
      }
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
      updatedData.dateShort = updatedData.AUX_B_VAL;
      this.calendar.value = updatedData.auxBVal3;
      this.dateBValue = updatedData.auxBVal3;
      this.errorFormat = false;
      this.errorMinB = false;
      this.errorMinB101 = false;
      updatedData.inputValMinE = false;
    }
  }

  /**
   * @ignore
   */
  updateDataIsEsvent(updatedData: UpdateDataCalendar): void {
    const AUX_ACTUAL_DATE_101 = new Date();
    AUX_ACTUAL_DATE_101.setDate(Numbers.numberN101);
    if (AUX_ACTUAL_DATE_101.getTime() <= updatedData.AUX_B_VAL_CAL.getTime()) {
      this.errorMinB = false;
      this.errorMinB101 = true;
      updatedData.dateShort = '';
      updatedData.auxBVal3 = null;
      this.dateBValue = null;
      updatedData.inputValMinE = true;
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors({ required: true });
    } else {
      let errorsA: ValidationErrors = null;
      let errorE = false;
      const ERRORS: ValidationErrors = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).errors;
      if (ERRORS !== null) {
        delete ERRORS.required;
        errorE = Object.keys(ERRORS).length === 0;
      }
      errorsA = ERRORS;
      if (errorE === true) {
        errorsA = null;
      }
      this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).setErrors(errorsA);
      updatedData.dateShort = this.utils.parseDateToShort(updatedData.AUX_B_VAL_CAL);
      this.calendar.value = updatedData.AUX_B_VAL_CAL;
      this.dateBValue = updatedData.AUX_B_VAL_CAL;
      this.utils.textInput3 = updatedData.dateShort;
      this.errorFormat = false;
      this.errorMinB = false;
      this.errorMinB101 = false;
      updatedData.inputValMinE = false;
    }
  }

  /**
   * @ignore
   */
  updateRange(type?: string): void {
    // tslint:disable-next-line: prefer-const
    if (!this.tempFormData && this.FORM_DATA) {
      this.tempFormData = this.FORM_DATA;
    }
    if (!this.FORM_DATA || !this.utils.formDataUtils) {
      this.FORM_DATA = this.tempFormData;
      this.utils.formDataUtils = this.tempFormData;
    }
    const time: { timeTo: string; timeFrom: string; } = { timeTo: '', timeFrom: '' };
    this.utils.valDuration = this.FORM_DATA.get(this.DATA_CONFIG.start.linkFormPath[0]).value.insuranceDuration;
    this.utils.readonlyEnd = false;
    this.utils.minDate = new Date();
    if (this.utils.insureSelected !== 'particularTravelAsistance') {
      this.utils.minDate.setDate(new Date().getDate() + 1);
    }
    if (type !== undefined) {
      this.updateRangeIfNotType(time);
    } else {
      this.calculateDays2(this.calendar.value[0], this.calendar.value[1], this.DATA_CONFIG);
      this.FORM_DATA = this.utils.formDataUtils;
      time.timeFrom = this.utils.parseDateToShort(this.calendar.value[0]);
      time.timeTo = this.utils.parseDateToShort(this.calendar.value[1]);
      this.utils.textInput1 = time.timeFrom;
      this.utils.textInput2 = time.timeTo;
      this.utils.errorSFormat = false;
      this.utils.errorEFormat = false;
    }
    if ([time.timeFrom, time.timeTo].some(e => e === '1/0/1970')) { return; }
    if (this.calledFrom === 'from') {
      this.utils.minDate = this.calendar.value[0];
      if (this.utils.valDuration === 'Anual' || this.utils.valDuration === 'Larga Estancia') {
        this.utils.changeDates();
        time.timeTo = this.utils.parseDateToShort(this.utils.maxDate);
        this.utils.textInput2 = time.timeTo;
        this.calendar.value[1] = this.utils.maxDateV;
        this.calculateDays2(this.calendar.value[0], this.calendar.value[1], this.DATA_CONFIG);
        this.FORM_DATA = this.utils.formDataUtils;
      }
    }
    this.FORM_DATA.get(this.DATA_CONFIG.start.linkFormPath).setValue(time.timeFrom);
    if (time.timeFrom !== '' && time.timeTo === '') {
      this.utils.minDate = this.calendar.value[0];
      this.utils.maxDateV = '';
      this.utils.updateDefaulValue(this.calendar);
    }
    this.FORM_DATA.get(this.DATA_CONFIG.end.linkFormPath).setValue(time.timeTo);
    this.utils.formDataUtils = this.FORM_DATA;
    this.utils.errorType = Numbers.number1;
    this.utils.setErrorField(time.timeFrom, this.DATA_CONFIG.start.linkFormPath, this.utils.fieldHasErrorB,
      this.CAL_TYPE, this.DATA_CONFIG, this.TYPE_BORN, this.calendar);
    this.FORM_DATA = this.utils.formDataUtils;
    if (time.timeTo !== undefined) {
      this.utils.formDataUtils = this.FORM_DATA;
      this.utils.errorType = Numbers.number2;
      this.utils.setErrorField(time.timeTo, this.DATA_CONFIG.end.linkFormPath, this.utils.fieldHasErrorB2,
        this.CAL_TYPE, this.DATA_CONFIG, this.TYPE_BORN, this.calendar);
      this.FORM_DATA = this.utils.formDataUtils;
    }
  }

  /**
   * @ignore
   */
  onFocusInput(controlName: string[], num: number): void {
    this.FORM_DATA.get(controlName).markAsUntouched();
    this.utils.onFocusInputUtils(controlName, num, this.FORM_DATA, this.CAL_TYPE, this.calendar, this.DATA_CONFIG,
      this.TYPE_BORN);
    this.FORM_DATA = this.utils.formDataUtils;
  }

  /**
   * @ignore
   */
  setShowCalendar(status: boolean): void {
    this.showedCalendar = status;
    if (this.CAL_TYPE === 'range') {
      this.utilsExtended.stylesCalendar();
    }
  }

  /**
   * @ignore
   */
  getError(controlName: string, num: any): string {
    return this.utilsExtended.getErrorUtils(controlName, num, this.FORM_DATA);
  }

  /**
   * @ignore
   */
  updateRangeIfNotType(time: { timeTo: string; timeFrom: string; }): void {
    let auxSVal3: any = null;
    let auxEVal3: any = null;
    const AUX_S_VAL: string = this.utils.textInput1;
    const AUX_E_VAL: string = this.utils.textInput2;
    this.calendar.value = [];
    if (AUX_S_VAL !== '') {
      let auxSVal2: any = AUX_S_VAL.split('/');
      auxSVal2 = new Date(auxSVal2[1] + '-' + auxSVal2[0] + '-' + auxSVal2[Numbers.number2]);
      auxSVal3 = auxSVal2;
      if (!isNaN(auxSVal2.getTime())) {
        time.timeFrom = AUX_S_VAL;
        this.calendar.value.push(auxSVal3);
        this.utils.errorSFormat = false;
      } else {
        time.timeFrom = '';
        auxSVal3 = null;
        this.utils.errorSFormat = true;
      }
    }
    if (AUX_E_VAL !== '') {
      let auxEVal2: any = AUX_E_VAL.split('/');
      auxEVal2 = new Date(auxEVal2[1] + '-' + auxEVal2[0] + '-' + auxEVal2[Numbers.number2]);
      auxEVal3 = auxEVal2;
      if (!isNaN(auxEVal2.getTime())) {
        time.timeTo = AUX_E_VAL;
        this.calendar.value.push(auxEVal3);
        this.utils.errorEFormat = false;
      } else {
        time.timeTo = '';
        auxEVal3 = null;
        this.utils.errorEFormat = true;
      }
    }
    if (auxSVal3 !== null && auxEVal3 !== null) {
      this.calculateDays2(auxSVal3, auxEVal3, this.DATA_CONFIG);
      this.utils.dateValue = this.calendar.value;
      this.utils.errorSFormat = false;
      this.utils.errorEFormat = false;
    }
  }

  /**
   * @ignore
   */
  manageCalendar(): void {
    if (this.calendar) {
      this.utilsExtended.setYears(this.TYPE_BORN, this.utils.insureSelected);
      if (this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value) {
        this.calendar.inputFieldValue = this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value;
        this.utils.textInput3 = this.calendar.inputFieldValue;
      }
      if (!this.FORM_DATA.get(this.DATA_CONFIG.linkFormPath).value && this.DATA_CONFIG.value) {
        this.calendar.inputFieldValue = this.DATA_CONFIG.value;
        this.utils.textInput3 = this.calendar.inputFieldValue;
      }
      this.isSimple = true;
      this.fieldName3 = this.DATA_CONFIG.linkFormPath;
      this.utils.fieldRequired3 = this.DATA_CONFIG.required;
      this.getError(this.fieldName3, Numbers.number3);
    }
  }
}
